import { GameFrame } from '@/features/game-client/game-frame';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { buildEveriUrl } from '@/features/providers/everi/everi-url-builder';
import { FgpEveriLaunchData } from '@/features/providers/everi/types';
import { GameDataProp } from '@/features/providers/types';
import { useAppSelector } from '@/store/hooks';

export const Everi: React.FC<GameDataProp> = ({ data }: GameDataProp) => {
  const { gameName } = useAppSelector(gameContextSelector);
  const url = buildEveriUrl(data as FgpEveriLaunchData);

  return <GameFrame title={gameName} url={url} />;
};
